import axiosServices from 'utils/axios';
import { GenericTableConfigCreationDto, GenericTableConfigDto } from './dto';
import { InsideFifaBackOfficeEndpoints } from '../consts';

export const createConfig = async (config: GenericTableConfigCreationDto): Promise<GenericTableConfigDto> => {
    const res = await axiosServices.post(InsideFifaBackOfficeEndpoints.GenericTables.Configs, config);

    return res.data;
};
